import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// Language content
const content = {
  bn: {
    title: "Shikhun Italian",
    subtitle: "মজার উপায়ে ইতালিয়ান ভাষা শিখুন",
    cta: {
      title: "এখনই শুরু করুন!",
      subtitle: "হাজারো শিক্ষার্থীর সাথে যোগ দিন",
      createAccount: "নতুন অ্যাকাউন্ট তৈরি করুন",
      signIn: "সাইন ইন করুন"
    },
    features: [
      {
        title: "ব্যাকরণ বুস্ট",
        icon: "📚"
        
      },
      {
        title: "কথা বলার দক্ষতা",
        icon: "🗣️"
      },
      {
        title: "নিয়মিত অনুশীলন",
        icon: "⏰"
      },
      {
        title: "লেখার স্পষ্টতা",
        icon: "✍️"
      },
    ]
  },
  it: {
    title: "Shikhun Italian",
    subtitle: "Impara l'italiano in modo divertente",
    cta: {
      title: "Inizia Ora!",
      subtitle: "Unisciti a migliaia di studenti",
      createAccount: "Crea Nuovo Account",
      signIn: "Accedi"
    },
    features: [
      {

        title: "Boost Grammatica",
        icon: "📚"
      },
      {
        title: "Abilità Parlate",
        icon: "🗣️"
      },
      {
        title: "Pratica Giornaliera",
        icon: "⏰"
      },
      {
        title: "Chiarezza Scrittura",
        icon: "✍️"
      },
    ]
  },
  en: {
    title: "Shikhun Italian",
    subtitle: "Learn Italian the fun way",
    cta: {
      title: "Start Now!",
      subtitle: "Join thousands of learners",
      createAccount: "Create New Account",
      signIn: "Sign In"
    },
    features: [
      {
        title: "Grammar Boost",
        icon: "📚"
      },
      {
        title: "Speaking Skills",
        icon: "🗣️"
      },
      {
        title: "Practice Daily",
        icon: "⏰"
      },
      {
        title: "Writing Clarity",
        icon: "✍️"
      },
    ]
  }
};

const OnboardingScreen: React.FC = () => {
  const navigate = useNavigate();
  const { currentLanguage, setCurrentLanguage } = useLanguage();

  const currentContent = content[currentLanguage];

  return (
    <div className="onboarding-screen">
      <div className="onboarding-content">
        {/* Language Selector */}
        <div className="language-selector">
          <button 
            className={`lang-btn ${currentLanguage === 'bn' ? 'active' : ''}`}
            onClick={() => setCurrentLanguage('bn')}
          >
            <span className="flag">🇧🇩</span>
            <span className="text">বাংলা</span>
          </button>
          <button 
            className={`lang-btn ${currentLanguage === 'it' ? 'active' : ''}`}
            onClick={() => setCurrentLanguage('it')}
          >
            <span className="flag">🇮🇹</span>
            <span className="text">Italiano</span>
          </button>
          <button 
            className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => setCurrentLanguage('en')}
          >
            <span className="flag">🇺🇸</span>
            <span className="text">English</span>
          </button>
        </div>

        {/* Logo Section */}
        <div className="logo-section">
          <div className="logo">
            <img src="logo512.png" alt={currentContent.title} />
          </div>
          <h1>{currentContent.title}</h1>
          <p className="subtitle">{currentContent.subtitle}</p>
        </div>
        
        {/* Feature Boxes */}
        <div className="feature-boxes">
          {currentContent.features.map((feature, index) => {
            const colors = ['orange', 'purple', 'green', 'pink', 'blue', 'yellow'];
            return (
              <div key={index} className={`feature-box ${colors[index]}`}>
                
                <div className="box-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
              </div>
            );
          })}
        </div>
        
        {/* Action Buttons */}
        <div className="action-buttons">
          <button 
            className="btn-signin"
            onClick={() => navigate('/login')}
          >
            {currentContent.cta.signIn}
          </button>
          
          <button 
            className="btn-signup"
            onClick={() => navigate('/register')}
          >
            {currentContent.cta.createAccount}
          </button>
          
          <button 
            className="btn-guest"
            onClick={() => {
              // Set guest mode in localStorage
              localStorage.setItem('isGuest', 'true');
              // Use window.location to force full reload so App.tsx initializes with guest user
              window.location.href = '/home';
            }}
            style={{
              marginTop: '10px',
              padding: '14px 24px',
              fontSize: '0.95rem',
              fontWeight: '600',
              borderRadius: '12px',
              border: '2px solid #6B46C1',
              background: 'transparent',
              color: '#6B46C1',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              width: '100%'
            }}
          >
            Continue as Guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingScreen;
